module.exports = __webpack_public_path__ + "img/礼物.9fcd9c1e.png";